import { FilterKey } from "@studyportals/search-filters";

import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { Degree } from "@/models/Degree";
import { SortingState } from "@/sorting/SortingState";
import { ISeoMetaDataInfo } from "../../ISeoMetaDataInfo";
import { SeoMetaDataHandler } from "../../SeoMetaDataHandler";
import { SortingOptions } from "@/sorting/SortingOptions";

export class Area extends SeoMetaDataHandler {

	public async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		const selectionCount = this.selectionTypeCount(filterSelectionState);
		const countrySelected = await this.singleSelectionFor(FilterKey.COUNTRY, filterSelectionState);
		const areaSelected = await this.singleSelectionFor(FilterKey.AREA, filterSelectionState);
		const metaRankingSortSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);

		return metaRankingSortSelected && (
			(areaSelected && selectionCount === 1) || (areaSelected && countrySelected && selectionCount === 2));
	}

	protected async selfHandle(degree: Degree, filterSelectionState: FilterSelectionState): Promise<ISeoMetaDataInfo> {
		const area = this.getFilterOptionNameBy(FilterKey.AREA, filterSelectionState);
		const country = this.getFilterOptionNameBy(FilterKey.COUNTRY, filterSelectionState);
		const year = this.getCurrentYearForSeo();

		const seoInfo = {
			title: `Best Universities in ${area} for ${year} | SP Meta Ranking`,

			description:
				`Discover the top universities in ${area}, ${country} for ${year}. ` +
				`View our detailed rankings based on academic excellence, student life, and more.`
		};

		return Promise.resolve(seoInfo);
	}
}
